@let request = $request();
@let isLoading = isLoading$ | async;
@let isInitialLoad = $isInitialLoad();
@let formatDateWithLocale = $formatDateWithLocale();
@let getCheckList = $getCheckList();
@let shareRequestLink = $shareRequestLink();
@let isOpeningEpts = $isOpeningEpts();
@let openYaMaps = $openYaMaps();

@let requestDevices = $requestDevices();
@let devicesInstallQuality = $devicesInstallQuality();
@let mainFileGroups = $mainFileGroups();
@let requestComments = $requestComments();
@let requestFiles = $files();
@let fileCats = $fileCats();
@let workflowUrlButtonText = $workflowUrlButtonText();
@let workflowUrl = $workflowUrl();

@let requestHistoryLogsCounter = $requestHistoryLogsCounter();

<div
  class="x-card x-card_size_l p-[20px] mx-[20px] mb-10 mt-1"
  [tuiSkeleton]="!!(isLoading && isInitialLoad)"
>
  <!--HEADER BLOCK-->
  <section class="flex items-center mb-6 gap-3.5">
    <h1 class="text-[28px]/[24px] font-extrabold me-3.5 whitespace-nowrap">
      {{ 'request_form.summary.common_info' | translate }}
    </h1>
    <x-request-form-actual-address
      [isInsideDesktopSummary]="true"
      class="min-w-0"
    />
    <!--    Блок Регламенты-->
    @if ($canShowWorkflowsBlock()) {
      <div tuiGroup class="mx-auto">
        @if (workflowUrl && workflowUrlButtonText) {
          <button
            appearance="primary"
            size="m"
            tuiButton
            type="button"
            [routerLink]="'../' + workflowUrl"
          >
            <span class="px-1.5!">{{ workflowUrlButtonText }}</span>
          </button>
        }
        <button
          appearance="outline"
          size="m"
          tuiButton
          type="button"
          [routerLink]="'../workflows'"
        >
          {{ 'workflows.steps' | translate }}
        </button>
      </div>
    }

    <aside class="flex ms-auto gap-x-2">
      @if ($canShowWorkflowsBlock()) {
        <x-icon-button
          iconName="@tui.archive"
          [size]="44"
          [clickFunction]="openAllWorkflowsLogsModal.bind(this)"
          [backgroundPrimary]="true"
          [tuiHint]="'workflows.events_dialog.open_all_button' | translate"
          tuiHintAppearance="dark"
          [tuiHintShowDelay]="0"
        />
      }
      @if ($canManageRequestWorkflows()) {
        <x-icon-button
          iconName="@tui.wrench"
          [size]="44"
          [clickFunction]="openWorkflowsDebuggingModal.bind(this)"
          [backgroundPrimary]="true"
          [tuiHint]="'debug_panel.debug_button_hint' | translate"
          tuiHintAppearance="dark"
          [tuiHintShowDelay]="0"
        />
        <x-icon-button
          iconName="@tui.database"
          [size]="44"
          [clickFunction]="openWorkflowsSubmissionsInfoSheet.bind(this)"
          [backgroundPrimary]="true"
          [tuiHint]="'debug_panel.filling_button_hint' | translate"
          tuiHintAppearance="dark"
          [tuiHintShowDelay]="0"
        />
      }

      <x-icon-button
        iconName="x-icon::EPTS"
        [disabled]="!this.ePTS || isOpeningEpts"
        [size]="44"
        [clickFunction]="openEpts.bind(this)"
        [backgroundPrimary]="true"
        [tuiHint]="
          this.ePTS
            ? ('requests_list_item.epts_hint' | translate)
            : ('requests_list_item.epts_not_found' | translate)
        "
        tuiHintAppearance="dark"
        [tuiHintShowDelay]="0"
      />
      <x-icon-button
        iconName="x-icon::checklistLarge"
        [clickFunction]="getCheckList.bind(this)"
        [backgroundPrimary]="true"
        tuiHintAppearance="dark"
        [tuiHint]="'request_form.summary.checklist_hint' | translate"
        [tuiHintShowDelay]="0"
      />
      <x-icon-button
        iconName="x-icon::photo-lp"
        [disabled]="!this.lPPhoto"
        [size]="44"
        [clickFunction]="createLink.bind(this, 'lPPhoto')"
        [backgroundPrimary]="true"
        [tuiHint]="
          this.lPPhoto
            ? ('requests_list_item.lp_photo_hint' | translate)
            : ('requests_list_item.lp_photo_not_found' | translate)
        "
        tuiHintAppearance="dark"
        [tuiHintShowDelay]="0"
      />
      <x-icon-button
        iconName="x-icon::DL"
        [disabled]="!this.appKDl"
        [size]="44"
        [clickFunction]="createLink.bind(this, 'appKDl')"
        [backgroundPrimary]="true"
        [tuiHint]="
          this.appKDl
            ? ('requests_list_item.obrz_app_k_dl_hint' | translate)
            : ('requests_list_item.obrz_app_k_dl_not_found' | translate)
        "
        tuiHintAppearance="dark"
        [tuiHintShowDelay]="0"
      />
      <x-icon-button
        iconName="x-icon::DKP"
        [disabled]="!this.appKDkp"
        [size]="44"
        [clickFunction]="createLink.bind(this, 'appKDkp')"
        [backgroundPrimary]="true"
        [tuiHint]="
          this.appKDkp
            ? ('requests_list_item.obrz_app_k_dkp_hint' | translate)
            : ('requests_list_item.obrz_app_k_dkp_not_found' | translate)
        "
        tuiHintAppearance="dark"
        [tuiHintShowDelay]="0"
      />
      @if (this.$request().deliveryAddress) {
        <x-icon-button
          iconName="@tui.navigation"
          [clickFunction]="openYaMaps.bind(this)"
          [backgroundPrimary]="true"
        />
      }
      <x-icon-button
        iconName="@tui.share"
        [clickFunction]="shareRequestLink.bind(this)"
        [backgroundPrimary]="true"
      />
    </aside>
  </section>
  <!--END HEADER BLOCK-->
  <div class="grid grid-cols-3 gap-5 grid-rows-[repeat(4,auto)]">
    <!--Заявка (REQUEST) BLOCK-->
    <div
      class="x-card x-card_size_l x-white p-[20px] col-span-1 col-start-1 row-start-1 row-span-1"
      [tuiSkeleton]="!!(isLoading && isInitialLoad)"
    >
      <div class="flex justify-between items-center mb-4">
        <p class="x-font-body-1-bold">
          {{ 'request_form.summary.request' | translate }}
        </p>
        <p>
          @if (permissionService.canLogistChangeInstaller$ | async) {
            <button
              tuiButton
              type="button"
              size="s"
              appearance="secondary"
              (click)="openInstallerAssignmentModal()"
            >
              {{ 'request_form.summary.installer_assignment.edit' | translate }}
            </button>
          }
        </p>
      </div>

      <div class="flex items-center justify-between">
        <div class="x-font-body-1-bold">
          {{ request.releaseTime | releaseTimeParser }},
          {{ formatDateWithLocale(request.releaseDate) }}
          @if (request.timezone) {
            <span>({{ request.timezone }})</span>
          }
        </div>
      </div>
      <div class="flex items-center justify-between gap-1">
        <div class="flex flex-col">
          @if (request.contract) {
            <div class="x-font-body-4 mt-2.5 -mb-3">
              {{ 'request_form.summary.request_contract' | translate }}:
            </div>
            <ng-container
              [ngTemplateOutlet]="inputCopy"
              [ngTemplateOutletContext]="{
                value: request.contract,
                withIcon: true,
              }"
            />
          } @else {
            <p class="x-font-body-4 x-text-dark-75">
              {{ 'request_form.summary.contract_not_specified' | translate }}
            </p>
          }
        </div>
        <div>
          @if (request.projectNumber) {
            <div class="x-font-body-4 mt-2.5 -mb-3">
              {{ 'request_form.summary.request_project' | translate }}:
            </div>
            <ng-container
              [ngTemplateOutlet]="inputCopy"
              [ngTemplateOutletContext]="{
                value: request.projectNumber,
              }"
            />
          } @else {
            <p class="x-font-body-4 x-text-dark-75">
              {{
                'request_form.summary.request_project_not_specified' | translate
              }}
            </p>
          }
        </div>
      </div>

      <div class="mt-6 x-font-body-4 x-text-dark-75 flex-col">
        <p>
          {{ 'request_form.summary.counterparty' | translate }}:
          {{
            request.counterPartyName || 'common.not_specified_he' | translate
          }}
        </p>
        <p>
          {{
            'request_form.summary.installer_assignment.contractor' | translate
          }}:
          {{
            request.contractorCounterpartyId?.shortName ||
              request.contractorCounterpartyId?.name ||
              ('common.not_specified_he' | translate)
          }}
        </p>
        <p>
          {{
            'request_form.summary.installer_assignment.subdivision' | translate
          }}:
          {{
            request.contractorCounterpartySubdivisionId?.name ||
              ('common.not_specified_he' | translate)
          }}
        </p>
        <p>
          {{ 'request_form.summary.installer_assignment.zone' | translate }}:
          {{
            request.installZoneNameCashed ||
              request.installZoneId?.name ||
              ('common.not_specified_he' | translate)
          }}
        </p>
        <p>
          {{ 'request_form.summary.installer' | translate }}:
          @if (request.installerShort) {
            {{ request.installerShort }}
          } @else {
            {{ 'common.not_specified_he' | translate }}
          }
        </p>
        <p class="mt-6">
          {{ 'request_form.summary.created' | translate }}:
          {{
            formatDateWithLocale(request.contractDate) || 'common.not_specified'
              | translate
          }}
        </p>
        @for (field of request.visibleExtraFields; track field.name) {
          <p>
            {{ field.title }}:
            {{ request.getExtraFieldValue(field) }}
          </p>
        }
      </div>
    </div>
    <!--END Заявка (REQUEST) BLOCK-->

    <!--Объект (LEASING PRODUCT) BLOCK-->
    <div
      class="x-card x-card_size_l x-white p-5 box-border w-full col-span-1 col-start-1 row-start-2 row-span-2 flex justify-self-stretch"
      [tuiSkeleton]="!!(isLoading && isInitialLoad)"
    >
      <p class="x-font-body-1-bold mb-4">
        {{ 'request_form.summary.product' | translate }}
      </p>
      <div class="flex items-center justify-between">
        <div class="x-font-body-3-bold">
          {{
            request.car || 'request_form.summary.request_car_not_specified'
              | translate
          }}
          <p class="x-font-body-4 opacity-80">
            {{
              request.carType ||
                'request_form.summary.request_car_type_not_specified'
                | translate
            }}
          </p>
        </div>
      </div>
      @if (request.vin) {
        <ng-container
          [ngTemplateOutlet]="inputCopy"
          [ngTemplateOutletContext]="{
            value: request.vin,
          }"
        />
      } @else {
        <p class="x-font-body-4 x-text-dark-75">
          {{ 'request_form.summary.VIN_not_specified' | translate }}
        </p>
      }
      <div class="mt-6 x-font-body-4 x-text-dark-75 flex-col">
        <p>
          {{ 'request_form.summary.car_year' | translate }}:
          {{ request.carYear || 'common.not_specified_he' | translate }}
        </p>
        <p>
          {{ 'request_form.summary.car_category' | translate }}:
          {{ request.carCategory || 'common.not_specified_he' | translate }}
        </p>
        <p>
          {{ 'request_form.summary.manufacturerCountry' | translate }}:
          {{
            request.manufacturerCountry || 'common.not_specified_she'
              | translate
          }}
        </p>
      </div>
      <div class="flex justify-between items-center">
        <div class="w-full">
          <p class="x-font-body-3-bold mt-5">
            {{
              request.deliveryName ||
                'request_form.summary.delivery_name_not_specified' | translate
            }}
          </p>
          <p class="x-font-body-3">
            {{
              request.deliveryAddress ||
                'request_form.summary.delivery_address_not_specified'
                | translate
            }}
          </p>
        </div>
      </div>
      <p class="x-font-body-4 mt-5 opacity-80">
        {{ 'request_form.summary.delivery_person' | translate }}
      </p>
      <p class="x-font-body-3-bold">
        {{
          request.deliveryPersonName ||
            'request_form.summary.delivery_person_name_not_specified'
            | translate
        }}
      </p>
      @if (request.deliveryPersonPhone) {
        <div
          class="mt-5 x-white-secondary rounded-xl items-center w-fit px-3.5 py-2.5"
        >
          <a
            class="x-font-body-3-bold"
            [href]="'tel:' + request.deliveryPersonPhone"
            >{{ request.deliveryPersonPhone }}</a
          >
        </div>
      } @else {
        <p class="x-font-body-3-bold">
          {{
            'request_form.summary.delivery_person_phone_not_specified'
              | translate
          }}
        </p>
      }
    </div>
    <!--END Объект (LEASING PRODUCT) BLOCK-->

    <!-- товары/услуги (GOODS) BLOCK -->
    <div
      class="x-card x-card_size_l x-white p-5 h-full box-border col-span-1 col-start-2 row-start-1 row-span-1 flex! flex-col"
      [tuiSkeleton]="!!(isLoading && isInitialLoad)"
    >
      <a
        class="cursor-pointer"
        (click)="scrollToGoods()"
        routerLink="."
        fragment="goods"
      >
        <p class="x-font-body-1-bold mb-4">
          {{ 'request_form.summary.products_and_services' | translate }}
          @if (request.products?.length) {
            <span
              tuiBadge
              class="mx-1 font-medium! mb-1 entities-counter-badge"
              size="l"
              >{{ request.products!.length }}</span
            >
          }
          <tui-icon
            [style.border-width.rem]="0.25"
            icon="@tui.chevron-right"
          ></tui-icon>
        </p>
      </a>
      <!-- Список занимает всю оставшуюся высоту карточки (высоту ряда задают соседние блоки),
           но сам ряд не растягивает: basis-0 + минимум 203px -->
      <x-goods-block
        class="flex flex-col flex-1 basis-0 min-h-[203px] [&>div:first-child]:max-h-none [&>div:first-child]:flex-1 [&>div:first-child]:min-h-0"
        [requestDevices]="requestDevices"
        [devicesInstallQuality]="devicesInstallQuality"
        [request]="request"
      />
    </div>
    <!--END товары/услуги (GOODS) BLOCK -->

    <!-- Файлы BLOCK-->
    <div
      class="x-card x-card_size_l x-white p-[20px] col-span-1 col-start-2 row-start-2 row-span-1"
      [tuiSkeleton]="!!(isLoading && isInitialLoad)"
    >
      <a
        class="cursor-pointer"
        (click)="scrollToFiles()"
        routerLink="."
        fragment="files"
      >
        <p class="x-font-body-1-bold mb-4">
          {{ 'request_form.summary.files' | translate }}
          @if (requestFiles?.length) {
            <span
              tuiBadge
              class="mx-1 font-medium! mb-1 entities-counter-badge"
              size="l"
              >{{ requestFiles!.length }}</span
            >
          }
          <tui-icon
            [style.border-width.rem]="0.25"
            icon="@tui.chevron-right"
          ></tui-icon>
        </p>
      </a>
      <section class="overflow-y-auto max-h-[260px]">
        @for (group of mainFileGroups; track group.id) {
          <p
            class="font-bold mb-4.5 flex items-center gap-2.5"
            [ngClass]="{
              'opacity-50': !group.filesExists,
              'cursor-pointer': group.filesExists,
            }"
            (click)="openLastCatFile(group)"
          >
            @if (group.files.length) {
              @let file = group.files[group.files.length - 1];
              <x-file-preview
                [src]="file.path | filePreviewUrl"
                [title]="file.filename"
                [fallbackIcon]="'@tui.file'"
                [badge]="file.filename | fileExtension"
                [width]="64"
                [height]="64"
              ></x-file-preview>
            } @else {
              <tui-icon
                [style.border-width.rem]="0.25"
                [icon]="group.multi ? '@tui.folder' : '@tui.file'"
              />
            }
            {{ group.name }}
          </p>
        }
      </section>
    </div>
    <!--END Файлы BLOCK-->

    <!-- Лизингополучатель (LEASING SUBJECT PERSON) BLOCK-->
    <div
      class="x-card x-card_size_l x-white p-[20px] col-span-1 col-start-2 row-start-3 row-span-1"
      [tuiSkeleton]="!!(isLoading && isInitialLoad)"
    >
      <p class="x-font-body-1-bold mb-4">
        {{ 'request_form.summary.subject_person' | translate }}
      </p>

      <p class="x-font-body-3-bold">
        {{
          request.subjFullname ||
            'request_form.summary.subject_person_fullname_not_specified'
            | translate
        }}
      </p>
      @if (request.subjPhone) {
        <div
          class="mt-4 x-white-secondary rounded-xl items-center w-fit px-3.5 py-2.5"
        >
          <a
            class="typo-ui-m font-semibold"
            [href]="'tel:' + request.subjPhone"
            >{{ request.subjPhone }}</a
          >
        </div>
      } @else {
        <p class="x-font-body-4 x-text-dark-75">
          {{
            'request_form.summary.subject_person_phone_not_specified'
              | translate
          }}
        </p>
      }
      <div class="mt-6 x-font-body-4 x-text-dark-75 flex-col">
        <p>
          {{ 'request_form.summary.lessee_inn' | translate }}:
          {{ request.subjInn || 'common.not_specified_he' | translate }}
        </p>
        <p>
          {{
            request.subjName ||
              'request_form.summary.subject_name_not_specified' | translate
          }}
        </p>
      </div>
    </div>
    <!--END Лизингополучатель (LEASING SUBJECT PERSON) BLOCK-->

    <!-- Город выдачи (RELEASE CITY) BLOCK-->
    <div
      class="x-card x-card_size_l x-white py-[20px] h-full box-border col-span-1 col-start-3 row-start-1 row-span-1"
      [tuiSkeleton]="!!(isLoading && isInitialLoad)"
    >
      <p class="x-font-body-1-bold mb-4">
        {{ 'request_form.summary.release_city' | translate }}
      </p>
      <x-request-form-release-city [request]="$request()" />
    </div>
    <!--END Город выдачи (RELEASE CITY) BLOCK-->

    <!-- Комментарии (COMMENTS) BLOCK-->
    <div
      class="x-card x-card_size_l x-white py-[20px] h-full box-border col-span-1 col-start-3 row-start-2 row-span-2 px-0"
      [tuiSkeleton]="!!(isLoading && isInitialLoad)"
    >
      <x-request-form-comments
        [isInsideSummary]="true"
        [requestComments]="requestComments"
      />
    </div>
    <!--END Комментарии (COMMENTS) BLOCK-->

    <!-- детали сделки (DEAL-DETAILS) BLOCK -->
    <div
      class="x-card x-card_size_l x-white p-[20px] h-full box-border col-span-3 col-start-1 row-start-4 row-span-1 min-h-[302px]"
      [tuiSkeleton]="!!(isLoading && isInitialLoad)"
    >
      <header class="flex items-center justify-between mb-4">
        <p class="x-font-body-1-bold">
          {{ 'request_form.summary.deal_details' | translate }}
        </p>
        @if (
          (permissionService.canEditDealDetails$ | async) && dealDetailsExist
        ) {
          <x-icon-button
            iconName="@tui.pencil"
            [iconSize]="16"
            [size]="32"
            class="self-end"
            [clickFunction]="
              showDealDetailsModal.bind(this, dealDetailsModalContent)
            "
          />
        }
      </header>
      <x-request-form-deal-details
        [isInsideSummary]="true"
        [dealDetails]="$dealDetails()"
      />
    </div>
    <!-- END детали сделки (DEAL-DETAILS) BLOCK -->
  </div>
  <ng-template #dealDetailsModalContent let-observer>
    <x-request-form-deal-details
      [groupActionMode]="false"
      [viewObserver]="observer"
    />
  </ng-template>
</div>

<!-- ПОЛНЫЙ БЛОК ДОПОЛНИТЕЛЬНО -->
<div
  class="x-card x-card_size_l p-[20px] mx-[20px] mb-10 mt-10"
  [tuiSkeleton]="!!(isLoading && isInitialLoad)"
>
  <h1 class="text-[28px]/[24px] font-extrabold mb-6">
    {{ 'request_form.summary.additionally' | translate }}
  </h1>
  <section class="grid grid-cols-3 gap-5">
    <x-request-form-common-obd [isInsideSummary]="true" />
    @if (request.hasEDO) {
      <x-request-form-inspection [isInsideSummary]="true" />
    }
    @if (permissionService.canViewQualityControlStatuses$ | async) {
      <x-request-form-qc [isInsideSummary]="true" />
    }
  </section>
</div>
<!-- END ПОЛНЫЙ БЛОК ДОПОЛНИТЕЛЬНО -->

<!-- ПОЛНЫЙ товары/услуги БЛОК -->
<div
  class="x-card x-card_size_l p-[20px] mx-[20px] mb-10 mt-10"
  [tuiSkeleton]="!!(isLoading && isInitialLoad)"
>
  <section class="flex items-center justify-between mb-6" id="goods" #goods>
    <h1 class="text-[28px]/[24px] font-extrabold">
      {{ 'request_form.summary.products_and_services' | translate }}
      @if (request.products?.length) {
        <span
          tuiBadge
          class="mx-1 font-medium! mb-1 entities-counter-badge"
          size="l"
          >{{ request.products?.length }}</span
        >
      }
    </h1>
    @if (
      (permissionService.canCompleteProducts$ | async) &&
      canCompleteSomeProducts()
    ) {
      <button
        tuiButton
        [style.border-radius.rem]="100"
        appearance="outline"
        type="button"
        size="m"
        class="mt-2 complete-button"
        [tuiSkeleton]="!!isLoading"
        [disabled]="!!isLoading"
        (click)="tryToCompleteAllProducts()"
      >
        <span class="x-font-body-4">
          {{ 'request_form.goods.complete_all' | translate }}
        </span>
      </button>
    }
  </section>
  <x-request-form-goods
    [isInsideSummary]="true"
    [completeAllProducts]="$completeAllProducts"
  />
</div>
<!-- END ПОЛНЫЙ товары/услуги БЛОК -->

<!-- ПОЛНЫЙ файлы BLOCK -->
<div
  class="x-card x-card_size_l p-[20px] mx-[20px] mb-10 mt-10"
  [tuiSkeleton]="!!(isLoading && isInitialLoad)"
>
  <section class="flex items-center justify-between mb-6" id="files" #files>
    <div class="flex items-center">
      <h1 class="text-[28px]/[24px] font-extrabold">
        {{ 'request_form.summary.files' | translate }}
        @if (requestFiles?.length) {
          <span
            tuiBadge
            class="mx-1 font-medium! mb-1 entities-counter-badge"
            size="xl"
            >{{ requestFiles!.length }}</span
          >
        }
      </h1>
      <tui-tabs
        class="h-[36px]! overflow-x-auto! shadow-none! ms-5"
        underline="transparent"
        [(activeItemIndex)]="fileTabIndex"
      >
        @for (tab of fileTabs; track tab; let idx = $index) {
          <button
            tuiTab
            [ngClass]="{ 'x-white': idx === fileTabIndex }"
            class="x-font-body-4-bold-important x-text-dark-main px-3.5! py-2! rounded-[12px] ms-0!"
            (click)="onFileTabClick(tab)"
          >
            {{
              'request_form.tabs.' + RequestFormFilesTabTitlesTranslateKeys[tab]
                | translate
            }}
          </button>
        }
      </tui-tabs>
    </div>
    @if (fileTabIndex !== 2) {
      <x-icon-button
        [size]="32"
        iconName="@tui.plus"
        class="self-end"
        [clickFunction]="showFileModal.bind(this)"
        [backgroundPrimary]="true"
      />
    }
  </section>
  <x-files-block
    [fileTabChange]="$fileTabChange"
    [showFileModal]="$showFileModal"
    [files]="requestFiles"
    [fileCats]="fileCats"
  />
</div>
<!-- END ПОЛНЫЙ файлы BLOCK -->

<!-- ПОЛНЫЙ устройства БЛОК -->
<div
  id="devices"
  class="x-card x-card_size_l p-[20px] mx-[20px] mb-10 mt-10"
  [tuiSkeleton]="!!(isLoading && isInitialLoad)"
>
  <section class="flex items-center mb-6 justify-between">
    <h1 class="text-[28px]/[24px] font-extrabold flex items-center">
      {{ 'request_form.summary.devices' | translate }}
    </h1>
    @if (
      !request.isCompleted &&
      (permissionService.canLogistAddDevices$ | async) &&
      doesCurrentRequestHasDevicesInProducts()
    ) {
      <x-icon-button
        iconName="@tui.plus"
        class="self-end"
        [size]="32"
        [clickFunction]="toggleAddDeviceForm.bind(this)"
        [backgroundPrimary]="true"
      />
    }
  </section>
  <x-request-form-devices
    [requestDevices]="requestDevices"
    [devicesInstallQuality]="devicesInstallQuality"
    [isInsideSummary]="true"
    [toggleAddDeviceForm]="$toggleAddDeviceForm"
  />
</div>
<!-- END ПОЛНЫЙ устройства BLOCK -->

<!-- ПОЛНЫЙ история заявки BLOCK -->
<div
  class="x-card x-card_size_l p-[20px] mx-[20px] mb-10 mt-10"
  [tuiSkeleton]="!!(isLoading && isInitialLoad)"
>
  <section
    class="flex items-center justify-between"
    [ngClass]="{ 'mb-6': showRequestHistoryBlock }"
  >
    <div class="flex items-center">
      <h1 class="text-[28px]/[24px] font-extrabold">
        {{ 'request_form.summary.history' | translate }}
      </h1>
      @if (requestHistoryLogsCounter > 0) {
        <span
          tuiBadge
          class="mx-1 font-medium! entities-counter-badge p-0!"
          size="xl"
          >{{ requestHistoryLogsCounter.toString() }}</span
        >
      }
      @if (showRequestHistoryBlock) {
        <tui-tabs
          class="h-[36px]! overflow-x-auto! shadow-none! ms-5"
          underline="transparent"
          [(activeItemIndex)]="historyTabIndex"
        >
          @for (tab of historyTabs; track tab; let idx = $index) {
            <button
              tuiTab
              [ngClass]="{ 'x-white': idx === historyTabIndex }"
              class="x-font-body-4-bold-important x-text-dark-main px-3.5! py-2! rounded-[12px] ms-0!"
              (click)="onHistoryTabClick(tab)"
            >
              {{
                'request_form.request_change_logs.' +
                  HistoryLogTabsTitlesTranslateKeys[tab] | translate
              }}
            </button>
          }
        </tui-tabs>
      }
    </div>
    @if (showRequestHistoryBlock) {
      <tui-textfield
        tuiTextfieldSize="m"
        iconStart="@tui.search"
        [tuiTextfieldCleaner]="true"
        class="w-1/2 rounded-[16px]! x-white"
      >
        <label tuiLabel
          ><span class="x-font-body-3">{{
            'request_form.request_change_logs.search_placeholder' | translate
          }}</span></label
        >
        <input
          tuiInput
          class="x-font-body-3-important"
          [(ngModel)]="historySearch"
          (ngModelChange)="onHistorySearchChange()"
        />
      </tui-textfield>
    }

    <x-icon-button
      [size]="32"
      [iconName]="
        showRequestHistoryBlock ? '@tui.chevron-up' : '@tui.chevron-down'
      "
      class="self-end"
      [clickFunction]="toggleRequestHistoryBlock.bind(this)"
      [backgroundPrimary]="true"
    />
  </section>
  <tui-expand [expanded]="showRequestHistoryBlock">
    <x-change-history
      [showRequestHistoryLogs]="$showRequestHistoryLogs"
      [historyLogsTabChange]="$historyLogsTabChange"
      [historyLogsSearchChanged]="$historyLogsSearchChanged"
      ($requestHistoryLogsCounterOutput)="
        onRequestHistoryLogsCounterOutput($event)
      "
    />
  </tui-expand>
</div>
<!-- END ПОЛНЫЙ история заявки BLOCK -->
<!-- //////////////////////////////////////////////////////////////////////// -->

<ng-template #inputCopy let-value="value" let-withIcon="withIcon">
  <div
    class="mt-4.5 flex justify-between bg-(--x-color-grayBG) rounded-xl items-center w-fit gap-2.5 h-[42px]!"
  >
    <span class="ms-2.5 x-font-body-3-bold flex items-center">
      @if (withIcon) {
        <img
          class="me-1.5"
          [ngSrc]="requestIconResolver(request.counterpartyOwnerId.id)"
          alt="cp icon"
          width="16"
          height="16"
        />
      }
      {{ value }}
    </span>
    <button
      class="me-2.5"
      appearance="icon"
      iconStart="@tui.copy"
      size="s"
      tuiIconButton
      [tuiAppearanceState]="true ? 'active' : null"
      (click)="copyToClipboard(value)"
    ></button>
  </div>
</ng-template>

<x-image-preview
  [files]="requestFiles"
  [request]="request"
  [showPreviewImageData]="$showPreviewImage"
/>
